'use client';

import { useInView } from '@/hooks/useInView';

/** Fades and lifts its content in once, when it first scrolls into view. */
export default function Reveal({ as: Tag = 'div', className = '', delay = 0, threshold = 0.15, children, ...rest }) {
  const { ref, inView } = useInView({ threshold });
  return (
    <Tag ref={ref} className={`reveal${inView ? ' in' : ''} ${className}`.trim()} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
}
